import {
  getGochiMenusEventData,
  getGochiMenuEventDetailData,
  addGochiMenuEventData,
  editGochiMenuEventData,
  changeStatusMenuEventData,
  addGochiMenuEventImageData,
  showHideGochiMenuEventData
} from '../libs/apis/GochiMenuEventApi';

export const GET_GOCHI_MENUS_EVENT_REQUEST = 'GET_GOCHI_MENUS_EVENT_REQUEST';
export const GET_GOCHI_MENUS_EVENT_SUCCESS = 'GET_GOCHI_MENUS_EVENT_SUCCESS';
export const GET_GOCHI_MENUS_EVENT_FAILURE = 'GET_GOCHI_MENUS_EVENT_FAILURE';

export const GET_GOCHI_MENU_EVENT_DETAIL_REQUEST =
  'GET_GOCHI_MENU_EVENT_DETAIL_REQUEST';
export const GET_GOCHI_MENU_EVENT_DETAIL_SUCCESS =
  'GET_GOCHI_MENU_EVENT_DETAIL_SUCCESS';
export const GET_GOCHI_MENU_EVENT_DETAIL_FAILURE =
  'GET_GOCHI_MENU_EVENT_DETAIL_FAILURE';

export const ADD_GOCHI_MENU_EVENT_REQUEST = 'ADD_GOCHI_MENU_EVENT_REQUEST';
export const ADD_GOCHI_MENU_EVENT_SUCCESS = 'ADD_GOCHI_MENU_EVENT_SUCCESS';
export const ADD_GOCHI_MENU_EVENT_FAILURE = 'ADD_GOCHI_MENU_EVENT_FAILURE';

export const EDIT_GOCHI_MENU_EVENT_REQUEST = 'EDIT_GOCHI_MENU_EVENT_REQUEST';
export const EDIT_GOCHI_MENU_EVENT_SUCCESS = 'EDIT_GOCHI_MENU_EVENT_SUCCESS';
export const EDIT_GOCHI_MENU_EVENT_FAILURE = 'EDIT_GOCHI_MENU_EVENT_FAILURE';

export const CHANGE_STATUS_MENU_EVENT_REQUEST =
  'CHANGE_STATUS_MENU_EVENT_REQUEST';
export const CHANGE_STATUS_MENU_EVENT_SUCCESS =
  'CHANGE_STATUS_MENU_EVENT_SUCCESS';
export const CHANGE_STATUS_MENU_EVENT_FAILURE =
  'CHANGE_STATUS_MENU_EVENT_FAILURE';

export const ADD_GOCHI_MENU_EVENT_IMAGE_REQUEST =
  'ADD_GOCHI_MENU_EVENT_IMAGE_REQUEST';
export const ADD_GOCHI_MENU_EVENT_IMAGE_SUCCESS =
  'ADD_GOCHI_MENU_EVENT_IMAGE_SUCCESS';
export const ADD_GOCHI_MENU_EVENT_IMAGE_FAILURE =
  'ADD_GOCHI_MENU_EVENT_IMAGE_FAILURE';

export const SHOW_HIDE_GOCHI_MENU_EVENT_REQUEST =
  'SHOW_HIDE_GOCHI_MENU_EVENT_REQUEST';
export const SHOW_HIDE_GOCHI_MENU_EVENT_SUCCESS =
  'SHOW_HIDE_GOCHI_MENU_EVENT_SUCCESS';
export const SHOW_HIDE_GOCHI_MENU_EVENT_FAILURE =
  'SHOW_HIDE_GOCHI_MENU_EVENT_FAILURE';

export const getGochiMenusEvent = params => dispatch => {
  dispatch({ type: GET_GOCHI_MENUS_EVENT_REQUEST });
  return getGochiMenusEventData(params)
    .then(response =>
      dispatch({
        type: GET_GOCHI_MENUS_EVENT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GOCHI_MENUS_EVENT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGochiMenuEventDetail = menuEventId => dispatch => {
  dispatch({ type: GET_GOCHI_MENU_EVENT_DETAIL_REQUEST });
  return getGochiMenuEventDetailData(menuEventId)
    .then(response =>
      dispatch({
        type: GET_GOCHI_MENU_EVENT_DETAIL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GOCHI_MENU_EVENT_DETAIL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addGochiMenuEvent = params => dispatch => {
  dispatch({ type: ADD_GOCHI_MENU_EVENT_REQUEST });
  return addGochiMenuEventData(params)
    .then(response =>
      dispatch({
        type: ADD_GOCHI_MENU_EVENT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_GOCHI_MENU_EVENT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editGochiMenuEvent = (menuEventId, params) => dispatch => {
  dispatch({ type: EDIT_GOCHI_MENU_EVENT_REQUEST });
  return editGochiMenuEventData(menuEventId, params)
    .then(response =>
      dispatch({
        type: EDIT_GOCHI_MENU_EVENT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_GOCHI_MENU_EVENT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const changeStatusMenuEvent = (menuEventId, params) => dispatch => {
  dispatch({ type: CHANGE_STATUS_MENU_EVENT_REQUEST });
  return changeStatusMenuEventData(menuEventId, params)
    .then(response =>
      dispatch({
        type: CHANGE_STATUS_MENU_EVENT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: CHANGE_STATUS_MENU_EVENT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addGochiMenuEventImage = (menuEventId, params) => dispatch => {
  dispatch({ type: ADD_GOCHI_MENU_EVENT_IMAGE_REQUEST });
  return addGochiMenuEventImageData(menuEventId, params)
    .then(response =>
      dispatch({
        type: ADD_GOCHI_MENU_EVENT_IMAGE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_GOCHI_MENU_EVENT_IMAGE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const showHideGochiMenuEvent = (menuId, paramShowHide) => dispatch => {
  dispatch({ type: SHOW_HIDE_GOCHI_MENU_EVENT_REQUEST });
  return showHideGochiMenuEventData(menuId, paramShowHide)
    .then(response =>
      dispatch({
        type: SHOW_HIDE_GOCHI_MENU_EVENT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: SHOW_HIDE_GOCHI_MENU_EVENT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
